import { programPhrases } from '../games/phrases';
import { prepareSpeech, serverVoice } from '../games/speak';

const BATCH = 300;
const sent = new Set<string>();

export function warmPrograms(
  programs: { kind: string; config?: Record<string, unknown> | null }[],
  voiceName: string | null | undefined,
  rate: number,
) {
  const voice = serverVoice(voiceName);
  if (!voice) return;
  const fresh: string[] = [];
  for (const p of programs) {
    for (const text of programPhrases(p.kind, p.config ?? {})) {
      const key = `${voice}|${rate}|${text.toLowerCase()}`;
      if (sent.has(key)) continue;
      sent.add(key);
      fresh.push(text);
    }
  }
  for (let i = 0; i < fresh.length; i += BATCH) {
    void prepareSpeech(fresh.slice(i, i + BATCH), voiceName ?? null, rate);
  }
}
